import { createReducer } from 'services/reduxHelpers'
import { modalTypes } from 'reduxModules/actions/ModalActions'
import { bookTypes } from 'reduxModules/actions/BookActions'

/* ------------- Initial State ------------- */

export const initialState = {
  open: false,
  type: null,
  data: null
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [modalTypes.SHOW_MODAL_ATTEMPT]: (_, { data: { type, data } }) => ({
    open: true,
    type,
    data
  }),
  [modalTypes.HIDE_MODAL_ATTEMPT]: () => ({
    ...initialState
  }),
  
  [bookTypes.ADD_SAVED_BOOKING_ATTEMPT]: () => ({
    ...initialState
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/ModalReducer.js